module.exports = __webpack_public_path__ + "img/ics_o_arrow_left.0b132f10.svg";